/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import pt from 'prop-types';
import Link from 'components/link';
import Table from 'components/collection/table';
import VersionStatus from 'components/apps/version-status';

export default class AppVersions extends React.PureComponent {
  static propTypes = {
    app: pt.object,
    onClickUnpublishRelease: pt.func,
  };

  getVersionActions(versionRecord) {
    const { onClickUnpublishRelease } = this.props;
    const actions = [];

    if (versionRecord.published) {
      actions.push(
        <a
          href=""
          onClick={onClickUnpublishRelease}
          data-version={versionRecord.version}
          className="collection-table-link"
        >
          Unpublish
        </a>,
      );
    }

    return actions;
  }

  getVersions() {
    const { app } = this.props;
    const { id, versions } = app;

    return versions?.results.map((versionRecord) => ({
      ...versionRecord,
      version: (
        <Link to={`/apps/${id}?version=${versionRecord.version}`}>
          {versionRecord.version}
        </Link>
      ),
      status: <VersionStatus app={this.props.app} version={versionRecord} />,
      supported: versionRecord.supported ? 'Yes' : 'No',
      actions: this.getVersionActions(versionRecord),
    }));
  }

  render() {
    return (
      <Table
        title="App versions"
        fields={[
          {
            label: 'Version',
            path: 'version',
          },
          {
            label: 'Status',
            path: 'status',
            nowrap: true,
          },
          {
            label: 'Description',
            path: 'description',
            className: 'wrap-anywhere',
          },
          {
            label: 'Supported',
            path: 'supported',
          },
          {
            label: 'Created',
            type: 'date',
            path: 'date_created',
          },
          {
            label: '',
            align: 'right',
            path: 'actions',
            // Sticks to the right edge while the table scrolls
            className: 'action',
          },
        ]}
        rows={this.getVersions()}
      />
    );
  }
}
